import React, { useMemo } from 'react';
import { Stop } from '@td-client-frontend/icons';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
import * as validatorUtils from '../ddf/validator-utils';

const ErrorWithIcon = ({ message, useCustomValidation, name }) => {
  const { getState, change } = useFormApi();
  const state = getState();

  const isCustomError: boolean = useMemo(() => {
    if (useCustomValidation) {
      return validatorUtils[useCustomValidation](name, state, change);
    }
    return false;
  }, [useCustomValidation, name, state, change]);

  if (useCustomValidation && !isCustomError) {
    return <></>;
  }

  return (
    <div className="flex items-center mb-3">
      <span>
        <Stop />
      </span>
      <p className="font-effra ml-3 font-normal text-gray-35">{message}</p>
    </div>
  );
};

export default ErrorWithIcon;
